<template>
    <div>
        <v-btn block elevation="0" @click="exportAll()">Выгрузить все</v-btn>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import ConfirmDialogue from '../helpers/ConfirmDialogue.vue'
export default {
    components: {
        ConfirmDialogue,
    },
    data(){
        return {
        }
    }, 
    methods: {
       async exportAll() {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Вы уверены, что хотите выгрузить информацию по всем профилям?',
                okButton: 'Начать',
            })
            if (ok) {
                this.$axios
                    .post(
                        '/api/downloadListAll/',
                        {
                        },
                        { responseType: 'arraybuffer' }
                    )
                    .then((data) => {
                        var fileURL = window.URL.createObjectURL(
                            new Blob([data.data], {
                                type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
                            })
                        )
                        var fileLink = document.createElement('a')
                        fileLink.href = fileURL
                        fileLink.setAttribute(
                            'download',
                            `1535-${new Date().toLocaleString('ru-RU')}.xlsx`
                        )
                        document.body.appendChild(fileLink)
                        fileLink.click()
                        this.$notify({
                            text: 'Файл загружается'
                        });
                    })
            }
        }
    }
}
</script>
<style>

</style>